import { Component, OnInit, HostBinding } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from '../application-service/application.service';
import { StorageService } from '../storage-service/storage.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { EulaService } from '../eula/eula.service';
import { ChangeDetectorRef } from '@angular/core';


@Component({
    selector: 'wbm-login',
    templateUrl: './login.component.html',
    styleUrls: ['../../assets/theme/css/Login.css'],
})
export class LoginComponent implements OnInit {
    @HostBinding() class = 'login flex-container-v relativeto h100';
    public selectedLanguage: string;
    public _backend: string;
    private _isEulaPopupActive: boolean = false;

    constructor(
        private cdRef: ChangeDetectorRef,
        private _translate: TranslateService,
        public _application: ApplicationService,
        private _storage: StorageService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _notification: NotificationsService,
        private _eulaService: EulaService
    ) { }

    public ngOnInit() {
        // reset login status
        this._authService.reset();

        this._notification.remove(); //remove all toasts

        this.selectedLanguage = this._application.getLanguage();

        if (this.isLoginDevRoute()) {
            this._backend = this._storage.retrieveBackend();
        } else {
            this._storage.removeBackend();
        }
    }
    public ngAfterViewInit() {
        // Safely update bindings after view is initialized
        this.cdRef.detectChanges();
    }


    public login(event: any, username: string, password: string) {
        if (username.length === 0 || password.length === 0) {
           this.isValid();
        } else {

            event.preventDefault();
            this._authService.login(username, password, this._backend);
        }
    }

    isLoginDevRoute() {
        return this._route.url['value'][0].path === 'login-dev';
    }

    setupCurrentLanguage() {
        this._translate.use(this.selectedLanguage);
        this._storage.storeLanguage(this.selectedLanguage);
    }

    public clickAboutBtn() {
        if (this._eulaService.isEulaDisplayed()) {
            this._isEulaPopupActive = false;
            return this._eulaService.enableEulaDisplay(false);
        } else {
            this._isEulaPopupActive = true;
            return this._eulaService.enableEulaDisplay(true);
        }
    }

    onMove(toltip: string) {
        let tolret;
        this._translate.get('login-tooltip')
            .subscribe((translatedString) => {
                tolret = translatedString;
            });
        if (toltip.length === 0) {
            return tolret;
        } else {
            return " ";
        }
    }

    isValid() {
            this._translate.get('credetials-notification')
            .subscribe((translatedMessage) => {
                this._notification.html(
                    `<aside class="flex-container nowrap flex-align-center notification notification--error icon__svg">
                    <span1 class="flex-item-fluid pas">` + translatedMessage + `</span>
                </aside>`, NotificationType.Bare, { timeOut: 0 });
            });

    }

}
